<div class="catalogs-wrapper">
    <section class="background-color-white" *ngIf="catalogs && catalogs.length > 0">
        <div class="container">
            <div class="catalogs" [class.quick-view-wrapper]="true" [class.long-view-wrapper]="false">
                <div *ngFor="let catalog of catalogs" class="catalog-item">
                    <da-catalog-item *ngIf="catalog" [catalog]="catalog"></da-catalog-item>
                </div>
            </div>
        </div>
    </section>
</div>
